import { StringUtils } from "abweb/utils/StringUtils";
export class LocaleTagUtils {
  /**
   * Ensures that a locale tag ends up in the IETF format (en-US and not en_US)
   *
   * @param localeTag
   * @returns {string}
   */
  static normalizeLocaleTagForClient(localeTag) {
    let tag = localeTag;
    if (tag && StringUtils.contains(tag, "_")) {
      tag = tag.replaceAll("_", "-");
    }
    return tag;
  }
  /**
   * Ensures that a locale tag ends up in the Java/POSIX format (en_US and not en-US)
   *
   * TODO: Server should be modified to accept standard locale strings (IETF format)
   *
   * @param localeTag
   * @returns {string}
   */
  static normalizeLocaleTagForServer(localeTag) {
    let tag = localeTag;
    if (tag && StringUtils.contains(tag, "-")) {
      tag = tag.replaceAll("-", "_");
    }
    return tag;
  }
}
//# sourceMappingURL=LocaleTagUtils.js.map
